import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuPortal,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";

interface LanguageSwitcherProps {
  isDarkTheme: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ isDarkTheme }) => {
  const { language, setLanguage, availableLanguages, getDisplayLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    setIsOpen(false);
  };

  return (
    <DropdownMenu 
      open={isOpen} 
      onOpenChange={setIsOpen}
      modal={false}
    >
      <DropdownMenuTrigger
        className={`flex items-center gap-1 px-2 py-1 rounded-md ${
          isDarkTheme 
            ? "text-white/80 hover:text-white hover:bg-white/10" 
            : "text-gray-700 hover:text-gray-900 hover:bg-gray-100"
        }`}
      >
        <Globe size={18} />
        <span className="uppercase text-xs font-medium">{getDisplayLanguage()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent
          className={`${isDarkTheme ? "bg-black/80 backdrop-blur-sm border border-white/10" : ""} w-[120px]`}
          sideOffset={8}
          align="end"
          avoidCollisions={true}
        >
          {availableLanguages.map((lang) => (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`${
                language === lang.code 
                  ? isDarkTheme 
                    ? "bg-anzir/20 text-white" 
                    : "bg-gray-100 text-gray-900"
                  : ""
              } cursor-pointer`}
            >
              {lang.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
